<template lang="pug">
  
  div
    MHeader( page-title="Moonpull Internal Reporting" )
    div( class="row" )
      div( class="col-6" )
        MWidgetBatchDownloadByAdvertiser
        
    div( class="row" )
      div( class="col-6" )
        MWidgetTagAndCookieCsv
    div( class="row" )
      div( class="col-6" )
        MMultiBatchWidget
    div( class="row" )
      div( class="col-6" )
        MReasonsReportWidget
    div( class="row" )
      div( class="col-6" )
        MAiReportWidget

</template>

<style lang="scss" scoped>

</style>

<script>
import Vue from 'vue'
export default Vue.extend({
})
</script>